import axios from 'axios'
import { UrlApi } from '../Keys'
import { toast } from 'react-toastify';

let loadingToast = null

const ToastLoading = (msj) => {
    loadingToast = toast.info(msj, {
        theme: "dark",
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
    })
}

const ToastSuccess = (msj) => {
    toast.success(msj, {
        theme: "dark",
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        onOpen: () => {
            if (loadingToast !== null) {
                toast.dismiss(loadingToast)
            }
        },
    })
}

const ToastError = (msj) => {
    toast.error(msj, {
        theme: "dark",
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        onOpen: () => {
            if (loadingToast !== null) {
                toast.dismiss(loadingToast)
            }
        },
    })
}

const dataInicial = {
    gestionesAbiertas: [],
    loadingGa: false,
    gestionesResueltas: [],
    loadingGr: false,
    creacionGestion: '',
    loadingGestion: false,
    incidencia: '',
    creacionIncidencia: '',
    loadingIncidencia: false,
    incidentesAbiertos: [],
    loadingIa: false,
    incidentesResueltos: [],
    loadingIr: false,
    adjuntos: [],
    loadingAdjuntos: false,
}

const LOADING_GA = 'LOADING_GA'
const GESTIONES_ABIERTAS = 'GESTIONES_ABIERTAS'
const GESTIONES_ABIERTAS_ERROR = 'GESTIONES_ABIERTAS_ERROR'

const LOADING_GR = 'LOADING_GR'
const GESTIONES_RESUELTAS = 'GESTIONES_RESUELTAS'
const GESTIONES_RESUELTAS_ERROR = 'GESTIONES_RESUELTAS_ERROR'

const NUEVA_GESTION_EXITO = 'NUEVA_GESTION_EXITO'
const GESTION_ERROR = 'GESTION_ERROR'

const NUEVA_INCIDENCIA_EXITO = 'NUEVA_INCIDENCIA_EXITO'
const INCIDENCIA_ERROR = 'GESTION_ERROR'

const LOADING_IA = 'LOADING_IA'
const INCIDENTES_ABIERTAS = 'INCIDENTES_ABIERTAS'
const INCIDENTES_ABIERTAS_ERROR = 'INCIDENTES_ABIERTAS_ERROR'

const LOADING_IR = 'LOADING_IR'
const INCIDENTES_RESUELTAS = 'INCIDENTES_RESUELTAS'
const INCIDENTES_RESUELTAS_ERROR = 'INCIDENTES_RESUELTAS_ERROR'

const LOADING_ADJUNTOS = 'LOADING_ADJUNTOS'
const ADJUNTOS = 'ADJUNTOS'
const ADJUNTOS_ERROR = 'ADJUNTOS_ERROR'

const LIMPIAR_ESTADOS = 'LIMPIAR_ESTADOS'
const LIMPIAR_ADJUNTOS = 'LIMPIAR_ADJUNTOS'

export default function ghRespondeReducer(state = dataInicial, action) {
    switch (action.type) {
        case GESTIONES_ABIERTAS:
            return { ...state, gestionesAbiertas: action.payload, loadingGa: action.loadingGa }
        case GESTIONES_RESUELTAS:
            return { ...state, gestionesResueltas: action.payload, loadingGr: action.loadingGr }
        case LOADING_GA:
            return { ...state, loadingGa: action.loadingGa }
        case LOADING_GR:
            return { ...state, loadingGr: action.loadingGr }
        case NUEVA_GESTION_EXITO:
            return { ...state, creacionGestion: action.creacionGestion }
        case GESTION_ERROR:
            return { ...state, creacionGestion: action.creacionGestion }
        case NUEVA_INCIDENCIA_EXITO:
            return { ...state, incidencia: action.payload, creacionIncidencia: action.creacionIncidencia }
        case INCIDENCIA_ERROR:
            return { ...state, creacionIncidencia: action.creacionIncidencia }
        case INCIDENTES_ABIERTAS:
            return { ...state, incidentesAbiertos: action.payload, loadingIa: action.loadingIa }
        case INCIDENTES_RESUELTAS:
            return { ...state, incidentesResueltos: action.payload, loadingIr: action.loadingIr }
        case LOADING_IA:
            return { ...state, loadingIa: action.loadingIa }
        case LOADING_IR:
            return { ...state, loadingIr: action.loadingIr }
        case ADJUNTOS:
            return { ...state, adjuntos: action.payload, loadingAdjuntos: action.loadingAdjuntos }
        case LOADING_ADJUNTOS:
            return { ...state, loadingAdjuntos: action.loadingAdjuntos }
        case ADJUNTOS_ERROR:
            return { ...state, loadingAdjuntos: action.loadingAdjuntos }
        case LIMPIAR_ESTADOS:
            return {
                ...state,
                gestionesAbiertas: [],
                loadingGa: false,
                gestionesResueltas: [],
                loadingGr: false,
                creacionGestion: '',
                loadingGestion: false,
                incidencia: '',
                creacionIncidencia: '',
                loadingIncidencia: false,
                incidentesAbiertos: [],
                loadingIa: false,
                incidentesResueltos: [],
                loadingIr: false,
                adjuntos: [],
                loadingAdjuntos: false,
            }
        case LIMPIAR_ADJUNTOS:
            return {
                ...state,
                adjuntos: [],
                loadingAdjuntos: false,
            }
        default:
            return { ...state }
    }
}

export const nuevaGestion = (empleado, objeto, token) => (dispatch) => {
    const { new_name, new_tipodeincidencia, new_tema, new_descripcion } = objeto;
    ToastLoading("Procesando...")
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(`${UrlApi}api/hrfactors/gestion`,
                {
                    new_name: new_name,
                    new_empleado: empleado,
                    new_tipodeincidencia: new_tipodeincidencia,
                    new_tema: new_tema.value,
                    new_descripcion: new_descripcion,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            dispatch({
                type: NUEVA_GESTION_EXITO,
                creacionGestion: "EXITO",
                loadingGestion: false,
            });
            resolve(response.data);
            ToastSuccess("Gestión creada con éxito!")
        } catch (error) {
            console.log(error);
            ToastError(error.message)
            dispatch({
                type: GESTION_ERROR,
                creacionGestion: "ERROR",
                loadingGestion: false,
            });
            reject(error);
        }
    }
    )
};

export const nuevaIncidencia = (empleado, objeto, token) => async (dispatch) => {
    const { new_name, new_tipodeincidencia, new_tema, new_descripcion } = objeto;
    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/incidenciadocente`,
                {
                    new_name: new_name,
                    new_empleado: empleado,
                    new_tipodeincidencia: new_tipodeincidencia,
                    new_tema: new_tema.value,
                    new_descripcion: new_descripcion,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: NUEVA_INCIDENCIA_EXITO,
                        payload: response.data,
                        creacionIncidencia: "EXITO",
                        loadingIncidencia: false,
                        // incidenciaId: id,
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: INCIDENCIA_ERROR,
                        creacionIncidencia: "ERROR",
                        loadingIncidencia: false,
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Gestión creada con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};

export const misGestionesAbiertas = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_GA,
        loadingGa: true,
    })

    try {
        var entidad = "new_incidencias"
        var fetch =
            "<entity name='new_incidencia'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='createdon'/>" +
            "<attribute name='new_tipodeincidencia'/>" +
            "<attribute name='new_origen'/>" +
            "<attribute name='new_altadeincidente'/>" +
            "<attribute name='new_empleado'/>" +
            "<attribute name='new_vencimiento'/>" +
            "<attribute name='new_incidenciaid'/>" +
            "<attribute name='new_tema'/>" +
            "<order attribute='new_vencimiento' descending='false'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "<condition attribute='statuscode' operator='eq' value='1'/>" +
            "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" + id + "'/>" +
            "</filter>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: GESTIONES_ABIERTAS,
            payload: response.data,
            loadingGa: false,
        })
    }
    catch (error) {
        dispatch({
            type: GESTIONES_ABIERTAS_ERROR,
            loadingGa: false,
        })
    }
}

export const misGestionesResueltas = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_GR,
        loadingGr: true,
    })

    try {
        var entidad = "new_incidencias"
        var fetch =
            "<entity name='new_incidencia'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='createdon'/>" +
            "<attribute name='new_tipodeincidencia'/>" +
            "<attribute name='new_origen'/>" +
            "<attribute name='new_empleado'/>" +
            "<attribute name='new_vencimiento'/>" +
            "<attribute name='new_fecharesolucion'/>" +
            "<attribute name='new_incidenciaid'/>" +
            "<attribute name='new_tema'/>" +
            "<attribute name='new_resolucion'/>" +
            "<order attribute='new_fecharesolucion' descending='true'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "<condition attribute='statuscode' operator='eq' value='100000000'/>" +
            "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" + id + "'/>" +
            "</filter>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: GESTIONES_RESUELTAS,
            payload: response.data,
            loadingGr: false,
        })
    }
    catch (error) {
        dispatch({
            type: GESTIONES_RESUELTAS_ERROR,
            loadingGr: false,
        })
    }
}

export const misIndicentesAbiertos = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_IA,
        loadingIa: true,
    })

    try {
        var entidad = "new_incidenciasdocenteses"
        var fetch =
            "<entity name='new_incidenciasdocentes'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='createdon'/>" +
            "<attribute name='new_vencimiento'/>" +
            "<attribute name='new_tipodeincidencia'/>" +
            "<attribute name='new_tema'/>" +
            "<attribute name='statuscode'/>" +
            "<attribute name='ownerid'/>" +
            "<attribute name='new_orgen'/>" +
            "<attribute name='new_idincidente'/>" +
            "<attribute name='new_empleado'/>" +
            "<attribute name='new_incidenciasdocentesid'/>" +
            "<order attribute='createdon' descending='true'/>" +
            "<order attribute='new_idincidente' descending='true'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "<condition attribute='statuscode' operator='eq' value='1'/>" +
            "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" + id + "'/>" +
            "</filter>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: INCIDENTES_ABIERTAS,
            payload: response.data,
            loadingIa: false,
        })
    }
    catch (error) {
        dispatch({
            type: INCIDENTES_ABIERTAS_ERROR,
            loadingIa: false,
        })
    }
}

export const misIndicentesResueltos = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_IR,
        loadingIr: true,
    })

    try {
        var entidad = "new_incidenciasdocenteses"
        var fetch =
            "<entity name='new_incidenciasdocentes'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='createdon'/>" +
            "<attribute name='new_vencimiento'/>" +
            "<attribute name='new_tipodeincidencia'/>" +
            "<attribute name='new_tema'/>" +
            "<attribute name='statuscode'/>" +
            "<attribute name='ownerid'/>" +
            "<attribute name='new_orgen'/>" +
            "<attribute name='new_idincidente'/>" +
            "<attribute name='new_empleado'/>" +
            "<attribute name='new_incidenciasdocentesid'/>" +
            "<attribute name='new_resolucion'/>" +
            "<order attribute='createdon' descending='true'/>" +
            "<order attribute='new_idincidente' descending='true'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "<condition attribute='statuscode' operator='eq' value='100000000'/>" +
            "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" + id + "'/>" +
            "</filter>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: INCIDENTES_RESUELTAS,
            payload: response.data,
            loadingIr: false,
        })
    }
    catch (error) {
        dispatch({
            type: INCIDENTES_RESUELTAS_ERROR,
            loadingIr: false,
        })
    }
}

export const limpiarEstadoCursos = () => {
    return {
        type: 'LIMPIAR_ESTADOS',
    };
};

export const limpiarAdjuntos = () => {
    return {
        type: 'LIMPIAR_ADJUNTOS',
    };
};

export const fetchAdjuntos = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_ADJUNTOS,
        loadingAdjuntos: true,
    })

    try {
        var entidad = "annotations"
        var fetch = `
        <entity name="annotation">
          <attribute name="subject" />
          <attribute name="notetext" />
          <attribute name="filename" />
          <attribute name="mimetype" />
          <attribute name="documentbody" />
          <attribute name="annotationid" />
          <order attribute="subject" descending="false" />
          <link-entity name="new_incidencia" from="new_incidenciaid" to="objectid" link-type="inner" alias="ab">
            <filter type="and">
              <condition attribute="new_incidenciaid" operator="eq" value="${id}" />
            </filter>
          </link-entity>
        </entity>`

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )

        dispatch({
            type: ADJUNTOS,
            payload: response.data,
            loadingAdjuntos: false,
        })
    } catch (error) {
        console.log(error);
        dispatch({
            type: ADJUNTOS_ERROR,
            loadingAdjuntos: false,
        })
    }finally {
        dispatch({
            type: LOADING_ADJUNTOS,
            loadingAdjuntos: false,
        });
    }
}